import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SafetySediOperativeService {
    static findByAzienda = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/sedi/findByAzienda`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    static show = (id_sede) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/sedi/show`;
            ApiService.postRequest(resolve, reject, url, { id_sede });
        });
    };

    static create = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/sedi/create`;
            ApiService.postRequest(resolve, reject, url, data);
        });
    };

    static update = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/sedi/update`;
            ApiService.putRequest(resolve, reject, url, data);
        });
    };

    static delete = (id_sede) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/sedi/delete`;
            ApiService.delete(resolve, reject, url, { id_sede });
        });
    };
}
